import React from 'react';
import { useGlobalConfig } from '../../components/globalConfig/GlobalConfigContext';


const basePath = '/assets/img/coming-soon/';
const images = [
  'lake-588572_1280.jpg',
  'poland-1750513_1280.jpg',
  'lake-6147490_1280.jpg',
  'lake-7642296_1280.jpg',
  'masuria-673603_1280.jpg',
  'masuria-1633777_1280.jpg',
  'masuria-4699272_1280.jpg',
  'masuria-5400801_1280.jpg',
  'night-927276_1280.jpg',
  'sunset-325878_1280.jpg',
  'the-lake-is-dystrophic-3425575_1280.jpg',
  'view-2069253_1280.jpg'
];

const ComingSoonPage = () => {


  return (
    <div className="container text-center py-5">
      {/* Logo */}
      <img src="/assets/img/logo.png" alt="Logo" className="mb-4" style={{ maxWidth: '150px' }} />

      {/* Powitalny tekst */}
      <h1 className="mb-3">Już wkrótce otwieramy stronę!</h1>
      <p className="lead mb-5">
        Będzie można zarezerwować domki na Mazurach online.
        {/*Do tego czasu zapraszamy do kontaktu w celu dokonania rezerwacji.*/}
      </p>


      {/* Masonry Gallery */}
      <div className="masonry mx-auto">
        {images.map((fileName, idx) => (
          <div className="masonry-item" key={idx}>
            <img
              src={basePath + fileName}
              alt={fileName}
              className="img-fluid rounded"
              loading="lazy"
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default ComingSoonPage;
